<template>
<div class='bodyer recharge'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-chongzhi2 float-left'></i>充值应答币
                </div>
                <div class='col-md-10'>
                    <a class='yi-btn white-o sm pull-right'
                        href='/#/recharge/log'>充值记录</a>
                    <a class='yi-btn white-o sm pull-right'
                        href='/#/recharge/redeem/log'>兑换记录</a>
                </div>
            </div>
        </div>
    </div>
    <div class='banner'>
        <img src='/static/image/recharge/banner.jpg'>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='title'>游戏充值</div>
            <div class='content row'>
                <div class='col-md-3'>
                    <ul class='list-group nav'>
                        <li class='list-group-item' :class='channel == "ali" ? "active" : ""'
                            @click='channel = step == 1 ? "ali" : channel'>
                            <img class='icon' src='/static/image/recharge/icon-ali.png'>
                            支付宝充值
                        </li>
                        <li class='list-group-item' :class='channel == "wx" ? "active" : ""'
                            @click='channel = step == 1 ? "wx" : channel'>
                            <img class='icon' src='/static/image/recharge/icon-wx.png'>
                            微信充值
                        </li>
                    </ul>
                </div>
                <div class='col-md-9'>
                    <div class='box-recharge' v-if='step == 1'>
                        <div class='title'>
                            您选择了{{ {'wx' : '微信', 'ali' : '支付宝'}[channel] }}充值应答币，请填写充值信息
                        </div>
                        <div class='box-form'>
                            <div class='form-inline'>
                                <label>充值帐号</label>
                                <input type='text' class='form-control' v-model='account' disabled>
                            </div>
                            <div class='form-inline'>
                                <label>充值金额</label>
                                <span class='select-item' v-for='item in amount_gear' 
                                    :class='item == amount ? "active" : ""'
                                    @click='amount = item'>
                                    {{item}}应答币
                                </span>

                            </div>
                            <div class='form-inline warning'>
                                <label>支付金额</label>
                                <span>{{amount}}元</span>
                            </div>
                        </div>
                        <div class='box-ops'>
                            <button class='yi-btn orange radius' @click='toRecharge()'>下一步</button>
                        </div>
                    </div>
                    <div class='box-payment' v-if='step == 2'>
                        <div class='payment-info row'>
                            <div class='col-md-8'>
                                <table style='width:100%'>
                                    <tr>
                                        <th>充值业务：</th>
                                        <td>{{amount}}应答币</td>
                                        <th rowspan='2'>
                                            总金额:
                                        </th>
                                        <td rowspan='2'>
                                            <span style='font-size:30px; color: #F33'>{{amount}}元</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>充值帐号：</th>
                                        <td>{{account}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class='col-md-4 box-btn'>
                                <button class='yi-btn orange' @click='editOrder()'>修改订单</button>
                            </div>
                        </div>

                        <div class='box-qrcode'>
                            <div class='row'>
                                <div class='col-md-3 offset-md-3'>
                                    <div class='qrcode' id='qrcode'></div>
                                    <div><img :src='"/static/image/recharge/pay-tip-"+channel+".png"'></div>
                                </div>
                                <div class='col-md-3'>
                                    <img :src='"/static/image/recharge/pay-show-"+channel+".png"'>
                                </div>
                            </div>
                            <br><br>
                            <div style='text-align:center'  v-if='!loop_check'>
                                <button class='yi-btn orange' @click='ctrlCheckTrade("start")'>已支付？检测</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Request from '@/common/Request'
import Common from '@/common/Common'
import Storage from '@/common/Storage'
import Notify from '@/common/Notify'
export default {
    data : function(){
        return {
            'channel' : 'wx',
            'account' : '',
            'amount' : 10,
            'amount_gear' : [10, 50, 100, 300, 500, 1000, 2000, 3000, 5000],
            'step' : 1,
            'trade_id' : false,
            'loop_count' : 0,
            'loop_handle' : false,
            'loop_check' : true,
        }
    },
    props : ['user', 'updateUser'],
    methods : {
        //发起充值
        toRecharge : function(){ 
            if(!this.account){
                Notify.error('请填写账号！');
                return false;
            }

            var url = Request.createApi('/app/recharge')
            var param = {
                'amount' : this.amount,
                'channel' : this.channel
            }

            Request.post(url, param, res => {
                this.step = 2
                this.trade_id = res.recharge.trade_id
                this.ctrlCheckTrade('start')
                setTimeout(function(){
                    new QRCode("qrcode", {
                        text: res.info,
                        width: 150,
                        height: 150,
                    });
                }, 100)
            })
        },

        //控制轮训检测
        ctrlCheckTrade : function(command){
            switch(command){
                case 'start':
                    this.loop_count = 1
                    this.loop_check = true
                    this.checkTrade()
                break;
                case 'stop':
                    this.loop_check = false
                break;
            }
        },     

        //轮训检测支付状态
        checkTrade : function(){
            this.loop_count++

            if(this.loop_count > 10){
                this.loop_check = false
            }

            if(!this.loop_check){
                //Notify.error('支付失败!')
                return true
            }
            this.loop_handle = setTimeout(() => {
                if(!this.trade_id){
                    return false
                }
                var url = Request.createApi('/app/trade/detail?id='+this.trade_id)
                Request.get(url, res => {
                    console.log(res)
                    if(res.info && res.info['status_pay'] == 'success'){
                        Notify.success('支付成功!')
                        this.updateUser()
                        Storage.set('trade', res.info)
                        Common.toUrl('/recharge/success')
                        return true
                    }else {
                        this.checkTrade()
                    }
                })
            }, 2000)       
        },

        //修改订单
        editOrder : function(){
            clearTimeout(this.loop_handle)
            this.ctrlCheckTrade('stop')
            this.step = 1
        }
    },
    mounted : function(){
        var channel = Common.getUrlParam('channel')
        if (channel == 'ali'){
            this.channel = 'ali'
        }
    },
    created : function(){
        window.scrollTo(0, 0)
        if(!this.user){
            Common.toUrl('/login')
            return true
        }
        this.account = this.user.username   
    }
}
</script>



// WEBPACK FOOTER //
// src/components/recharge/Pay.vue